import {
  GET_FORM_BY_ID_REQUEST,
  GET_FORM_BY_ID_SUCCESS,
  GET_FORM_BY_ID_FAILURE,
} from "../Types";

const initialState = {
  loading: false,
  form: null,
  error: null,
};

const GetFormFromIdReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_FORM_BY_ID_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case GET_FORM_BY_ID_SUCCESS:
      return {
        ...state,
        loading: false,
        form: action.payload,
      };

    case GET_FORM_BY_ID_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default GetFormFromIdReducer;
